import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import PreloadLogo from "@assets/images/logo-tarbiyatus.png";
import { LuAlertTriangle } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <BaseLayout>
      <div className="bg-semi-circle bg-gradient tw-h-[500px]">
        <svg
          className="curve"
          viewBox="0 0 100 12"
          preserveAspectRatio="none"
          style={{
            position: "absolute",
            bottom: "-1px",
            left: "0",
            width: "100%",
            height: "100px",
          }}
        >
          <path d="M0,0 Q50,3 100,0 L100,30 L0,30 Z" fill="#f9f9fb" />
        </svg>
      </div>
      <Header>
        <div className="page-title">
          <div className="tw-pt-24 tw-mb-10 tw-text-center">
            <img
              src={PreloadLogo}
              alt="Logo Tarbiyatus Shibyan"
              className="tw-w-3/5 tw-py-4 tw-px-[0px]"
            />
          </div>
        </div>
      </Header>
      <div className="tw-mt-12 tw-py-12 tw-mx-4 tw-text-center  tw-rounded-lg card-body">
        <div className="">
          <div>
            <LuAlertTriangle className="tw-text-red-500 tw-text-8xl" />
          </div>
          <div className="tw-font-bold tw-text-6xl tw-pt-3 tw-pb-2 tw-text-accent-primary">
            404
          </div>
          <div className="tw-text-uppercase tw-pb-3 tw-text-lg tw-font-medium tw-text-accent-primary">
            Halaman tidak ditemukan
          </div>
          <div
            className="tw-mx-auto tw-text-sm tw-text-text-secondary"
            style={{ maxWidth: "300px", width: "85%", lineHeight: "1.5" }}
          >
            Halaman yang kamu cari tidak bisa ditemukan. Kembali ke Beranda?
          </div>
          <div className="text-center">
            <Button
              className="tw-mt-12 tw-p-2 tw-h-10 tw-w-full tw-text-base tw-rounded-xl bg-gradient tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
              htmlType="button"
              onClick={() => navigate("/")}
            >
              Kembali
            </Button>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default NotFoundPage;
